module.exports = __webpack_public_path__ + "img/art_home_alone.a38b311e.jpg";